import { EventEmitter } from '@stencil/core';

type EventOrCustom<T> = T | CustomEvent;

interface ComponentWithSubInputsFocusBase {
	focused: boolean;
	touched: boolean;
}

interface ComponentWithSubInputsBlur extends ComponentWithSubInputsFocusBase {
	zdsBlur: EventEmitter;
}

export const onGenericSubInputBlur = (component: ComponentWithSubInputsBlur, event: EventOrCustom<FocusEvent>) => {
	event?.stopPropagation();

	component.touched = true;
	component.focused = false;

	component.zdsBlur.emit();
};

interface ComponentWithSubInputsChange {
	zdsChange: EventEmitter;
}

export const onGenericSubInputChange = (
	component: ComponentWithSubInputsChange,
	event: EventOrCustom<Event>,
	eventDetail?: object,
) => {
	event?.stopPropagation();
	component.zdsChange.emit(eventDetail);
};

interface ComponentWithSubInputsFocus extends ComponentWithSubInputsFocusBase {
	zdsFocus: EventEmitter;
}

export const onGenericSubInputFocus = (component: ComponentWithSubInputsFocus, event: EventOrCustom<FocusEvent>) => {
	event?.stopPropagation();

	component.focused = true;

	component.zdsFocus.emit();
};

interface ComponentWithSubInputsInput {
	zdsInput: EventEmitter;
}

export const onGenericSubInputInput = (
	component: ComponentWithSubInputsInput,
	event: EventOrCustom<InputEvent>,
	eventDetail?: unknown,
) => {
	event?.stopPropagation();
	component.zdsInput.emit(eventDetail);
};

interface ComponentWithSubInputsPaste {
	zdsChange: EventEmitter;
	zdsInput: EventEmitter;
}

export const onGenericSubInputPaste = (component: ComponentWithSubInputsPaste) => {
	component.zdsChange.emit();
};
